<section class="comparison-view" *ngIf="leftConfig && rightConfig; else missingComparisonConfig">
  <article class="comparison-pane">
    <header class="comparison-pane-header">
      <span>{{ leftConfig }}</span>
    </header>
    <ng-container *ngIf="renderDashboards">
      <app-dashboard
        [configFile]="leftConfig"
        [dashboardSourceKey]="'compare:left:' + leftConfig">
      </app-dashboard>
    </ng-container>
  </article>

  <article class="comparison-pane">
    <header class="comparison-pane-header">
      <span>{{ rightConfig }}</span>
    </header>
    <ng-container *ngIf="renderDashboards">
      <app-dashboard
        [configFile]="rightConfig"
        [dashboardSourceKey]="'compare:right:' + rightConfig">
      </app-dashboard>
    </ng-container>
  </article>
</section>

<ng-template #missingComparisonConfig>
  <div class="comparison-empty">
    Comparison dashboards are not configured.
  </div>
</ng-template>
